function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.44196 4.00002L7.90846 0.533488C8.03051 0.411441 8.03051 0.213566 7.90846 0.0915351C7.78642 -0.0304961 7.58854 -0.0305117 7.46651 0.0915351L3.99999 3.55806L0.533487 0.0915351C0.41144 -0.0305117 0.213566 -0.0305117 0.0915349 0.0915351C-0.030496 0.213582 -0.0305116 0.411457 0.0915349 0.533488L3.55804 4L0.0915349 7.46653C-0.0305116 7.58858 -0.0305116 7.78645 0.0915349 7.90848C0.15255 7.9695 0.232534 8 0.312519 8C0.392503 8 0.472471 7.9695 0.533502 7.90848L3.99999 4.44197L7.4665 7.90848C7.52751 7.9695 7.6075 8 7.68748 8C7.76747 8 7.84743 7.9695 7.90846 7.90848C8.03051 7.78644 8.03051 7.58856 7.90846 7.46653L4.44196 4.00002Z"
});

var SvgCancel = function SvgCancel(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCancel, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cancel.52b36148.svg";
export { ForwardRef as ReactComponent };